import { Drawer } from '@mui/material';

// Form
import { SetupMinesRoundDrawerContent } from './SetupMinesRoundDrawerContent';

// Redux
import { useDispatch } from 'react-redux';
import { useMinesRoundDrawer } from '@Modal/hooks/rounds/useMinesRoundDrawer';

export const SetupMinesRoundDrawer: React.FC = () => {
  const { showRoundDrawer, setShowRoundDrawer } = useMinesRoundDrawer();
  const dispatch = useDispatch();

  return (
    <Drawer
      anchor="right"
      open={showRoundDrawer}
      onClose={() => dispatch(setShowRoundDrawer(false))}
    >
      <SetupMinesRoundDrawerContent />
    </Drawer>
  );
};
